var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loadingBox},[_c('Loading',{class:_vm.$style.loading}),_c('img',{class:_vm.$style.light,attrs:{"src":require("./assets/light_icon.png")}}),_c('div',{class:_vm.$style.tips},[_vm._v(_vm._s(_vm.tips))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }